<template>
    <b-collapse :visible="showGraph" id="content">
        <card>
            <div slot="header" class="row align-items-center">
                <div class="col">
                    <h5 class="h3 mb-0">Carepoint Pricing</h5>
                </div>
            </div>
            <div class="overflow-auto">
                <b-pagination v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              aria-controls="pricingTable">
                </b-pagination>
                <b-table id="pricingTable"
                         :items="tableData"
                         :fields="tableColumns"
                         :per-page="perPage"
                         :current-page="currentPage"
                         small
                         striped>
                </b-table>
            </div>
        </card>
    </b-collapse>
</template>

<script>

    export default {
        name: 'pricing-charts',
        props: {
            selectedChart: String,
        },
        data() {
            return {
                showGraph: true,
                tableColumns: [],
                perPage: 20,
                currentPage: 1,
                tableData: [],
            };
        },
        methods: {
            fetchData() {
                var columns = [];
                this.axios.get(`Pricing/${this.selectedChart}/Schema`)
                    .then(response => {
                        response.data.forEach(column => columns.push({ key: column, sortable: true })
                        );
                    });
                this.tableColumns = columns;
                this.axios.get(`Pricing/${this.selectedChart}`)
                    .then(response => {
                        var row = 0;
                        var temp = [];
                        var datalength = 0;
                        while (row < this.tableColumns.length) {
                            temp = response.data.map(d => {
                                return {
                                    [this.tableColumns[row].key]: d[row]
                                }
                                
                            })
                            datalength = temp.length;
                            this.tableData.push(temp);
                            row++
                        }
                        this.tableData = this.tableData.reduce((a, b) => a.concat(b), []);

                        var curr = 0
                        var cols = 1
                        while (cols < this.tableColumns.length) {
                            while (curr < datalength) {
                                Object.assign(this.tableData[curr], this.tableData[(datalength * cols) + curr])
                                curr = curr + 1;
                            }
                            cols = cols + 1;
                            curr = 0;
                        }
                        this.tableData = this.tableData.splice(0, datalength)
                        
                    })
                    .catch(error => {

                    });
            },
        },
        watch: {
            selectedChart: function () {
                this.tableData = [];
                this.tableColumns = [];
                this.currentPage = 1
                this.fetchData()
            }
        },
        computed: {
            rows() {
                return this.tableData.length
            }
        },
        mounted() {
            this.fetchData();
        }
    }
</script>

<style scoped>
</style>